var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#007FA3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.21429V5.5C12 5.53789 11.986 5.57423 11.9609 5.60102C11.9359 5.62781 11.902 5.64286 11.8667 5.64286H11.4667V5.85715C11.4667 5.97549 11.3771 6.07143 11.2667 6.07143H4.73333C4.62288 6.07143 4.53333 5.97549 4.53333 5.85715V5.64286H4.13333C4.09797 5.64286 4.06406 5.62781 4.03905 5.60102C4.01405 5.57423 4 5.53789 4 5.5V5.21429C4 5.18603 4.00782 5.1584 4.02248 5.1349C4.03714 5.11141 4.05798 5.0931 4.08235 5.08229L7.94902 3.51086C7.98166 3.49638 8.01834 3.49638 8.05098 3.51086L11.9177 5.08229C11.942 5.0931 11.9629 5.11141 11.9775 5.1349C11.9922 5.1584 12 5.18603 12 5.21429ZM11.6 10.6429H4.4C4.17908 10.6429 4 10.8347 4 11.0714V11.3571C4 11.395 4.01405 11.4314 4.03905 11.4582C4.06406 11.4849 4.09797 11.5 4.13333 11.5H11.8667C11.902 11.5 11.9359 11.4849 11.9609 11.4582C11.986 11.4314 12 11.395 12 11.3571V11.0714C12 10.8347 11.8209 10.6429 11.6 10.6429ZM5.33333 6.35715V9.78572H4.73333C4.62288 9.78572 4.53333 9.88166 4.53333 10V10.3571H11.4667V10C11.4667 9.88166 11.3771 9.78572 11.2667 9.78572H10.6667V6.35715H9.6V9.78572H8.53333V6.35715H7.46667V9.78572H6.4V6.35715H5.33333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseIcon);
export default __webpack_public_path__ + "static/media/purchase-icon.b2dc5a14a054befa2b7ffdf4d97f5f51.svg";
export { ForwardRef as ReactComponent };